import React, {useEffect, useMemo, useState} from 'react';
import {Button, Row, Col} from 'antd';
import {translate} from 'react-i18next';
import EnhancedModal from "../../../../../components/enhanced-modal";
import {MODAL_WIDTH_LG} from "../../../../../styles/constants";
import InfiniteScrollDataTable from "../../../../../components/infinite-scroll-data-table";
import {getFilterObjFromViewerObj} from "../../../../../utils/filter";
import {compose} from "redux";
import {connect} from "react-redux";
import {
    getMappingSetPreviewToken,
    getMappingSetPreviewData,
    clearUpdatePreviewFlagMappingSet,
} from "../actions";
import {getSimplifiedFilterObj} from "../../../dataflow-publishing/utils";

const mapStateToProps = ({
                             config,
                             scenes: {mappingHandler: {mappingSet: {wizard, index}}}
                         }) => ({
    mappingSetPreview: wizard.mappingSetPreview,
    mappingSetPreviewToken: wizard.mappingSetPreviewToken,
    noMoreResults: wizard.noMoreResults,
    dataflow: index.dataflow,
    updatePreview: wizard.updatePreview,
    limitPagingMa: config.dataManagement.limitPagingMa
});

const mapDispatchToProps = dispatch => ({
    getMappedData: (pageNum, pageSize, filters, sortCol, sortByDesc, token) => dispatch(getMappingSetPreviewData(pageNum, pageSize, filters, sortCol, sortByDesc, token)),
    getMappingToken: (dataflowId, dataflowAgency, dataflowVersion, token, page, filter) => dispatch(getMappingSetPreviewToken(dataflowId, dataflowAgency, dataflowVersion, token, page, filter)),
    clearFlag: () => dispatch(clearUpdatePreviewFlagMappingSet()),
});

const ModalPreview = ({
                          t,
                          rows,
                          isRowsModalVisible,
                          onRowsModalHide,
                          getMappedData,
                          getMappingToken,
                          title,
                          width,
                          mappingSetPreviewToken,
                          dataflow,
                          dataflowTriplet,
                          updatePreview,
                          clearFlag,
                          noMoreResults,
                          limitPagingMa,
                          dataflowParams,
                          mappingSetPreview,
                      }) => {
    const [fetchedPage, setFetchedPage] = useState(1);
    const pageLimit = useMemo(() => Math.min(limitPagingMa, 198), [limitPagingMa]);
    const [fetchParams, setFetchParams] = useState({filters: [], sortCol: [], sortByDesc: false});
    const tableData = useMemo(() => rows || mappingSetPreview, [rows, mappingSetPreview]);

    useEffect(() => {
        if (updatePreview) {
            getMappedData(fetchedPage, pageLimit, fetchParams.filters, fetchParams.sortCol, fetchParams.sortByDesc, mappingSetPreviewToken);
            clearFlag();
        }
    }, [updatePreview, fetchParams])

    useEffect(() => {
        if (!mappingSetPreviewToken && fetchedPage > 1) {
            setFetchedPage(prevState => prevState - 1);
        }
    }, [fetchedPage, mappingSetPreviewToken]);

    return (
        <EnhancedModal
            visible={isRowsModalVisible}
            onCancel={() => {
                setFetchedPage(1);
                onRowsModalHide();
            }}
            footer={<Button onClick={() => {
                setFetchedPage(1);
                onRowsModalHide();
            }}>{t('commons.buttons.close.title')}</Button>}
            width={width || MODAL_WIDTH_LG}
            title={title || t('scenes.dataManager.dataflowBuilder.wizard.query.preview.rowsModal.title')}
        >
            {tableData && tableData.Data && <InfiniteScrollDataTable
                data={tableData && tableData.Data}
                cols={tableData && tableData.Columns}
                rowTotal={tableData && tableData.Count}
                rightActions={
                    (
                        <Row>
                            <Col>
                                <Button
                                    disabled={noMoreResults}
                                    onClick={() => setFetchedPage(prevState => {
                                        const newPage = fetchedPage + 1;
                                        if (dataflowTriplet) {
                                            getMappingToken(dataflowTriplet.id, dataflowTriplet.agencyID, dataflowTriplet.version, mappingSetPreviewToken, newPage, dataflowParams ? getSimplifiedFilterObj(dataflowParams.filter).Filter : null);
                                        } else {
                                            getMappingToken(dataflow.id, dataflow.agencyID, dataflow.version, mappingSetPreviewToken, newPage, dataflowParams ? getSimplifiedFilterObj(dataflowParams.filter).Filter : null);
                                        }
                                        return newPage
                                    })}>
                                    {t('scenes.dataManager.dataflowBuilder.wizard.query.preview.rowsModal.button')}
                                </Button>
                            </Col>
                        </Row>
                    )
                }
                isPaginated
                onChange={
                    mappingSetPreviewToken ? ({
                                                  pageNum,
                                                  pageSize,
                                                  searchText,
                                                  filters,
                                                  sortCol,
                                                  sortByDesc
                                              }) => {
                        getMappedData(
                            pageNum,
                            pageSize,
                            getFilterObjFromViewerObj(
                                tableData && tableData.Columns.filter(colName => colName !== 'NumRow'),
                                searchText,
                                filters
                            ),
                            sortCol ? [sortCol] : null,
                            sortByDesc,
                            mappingSetPreviewToken
                        );
                        setFetchParams({
                            filters: getFilterObjFromViewerObj(
                                tableData && tableData.Columns.filter(colName => colName !== 'NumRow'),
                                searchText,
                                filters
                            ), sortCol: sortCol ? [sortCol] : null, sortByDesc
                        })
                    } : null
                }
            />}
        </EnhancedModal>
    )
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(ModalPreview);
